import React from "react";
import "./styles.css";

// Ошибки валидации под инпутом. errors — массив строк (формат {field: [msgs]} бэкенда).
export default function MessageError({ errors }) {
    if (!errors) return null;
    const list = Array.isArray(errors) ? errors : [errors];
    if (list.length === 0) return null;
    return <div className="message__errors">
        {list.map((error, index) =>
            <div key={index} className="message__errors-item">{error}</div>
        )}
    </div>;
}
